// removed by extract-text-webpack-plugin
module.exports = {"main_right_content":"components-swbl-lstd-index-main_right_content-1d2oN","table":"components-swbl-lstd-index-table-3loOh"};


//////////////////
// WEBPACK FOOTER
// ./components/swbl/lstd/index.css
// module id = 819
// module chunks = 0